(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inline-field-errors"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__inlineFieldErrors) return;
    window.__inlineFieldErrors = true;

    function errorFor(field, create) {
      var id = field.dataset.errorId;
      var el = id && document.getElementById(id);
      if (el || !create) return el;
      id = 'inline-error-' + Math.random().toString(36).slice(2, 8);
      el = document.createElement('p');
      el.id = id;
      el.className = 'inline-field-error';
      el.setAttribute('role', 'alert');
      field.insertAdjacentElement('afterend', el);
      field.dataset.errorId = id;
      var described = (field.getAttribute('aria-describedby') || '') + ' ' + id;
      field.setAttribute('aria-describedby', described.trim());
      return el;
    }

    function inScope(field) {
      return field.matches && field.matches('input, select, textarea') && field.closest('form[data-inline-errors]');
    }

    // `invalid` doesn't bubble, so listen in the capture phase.
    document.addEventListener(
      'invalid',
      function (event) {
        var field = event.target;
        if (!inScope(field)) return;
        var el = errorFor(field, true);
        el.textContent = field.validationMessage;
        el.hidden = false;
        field.setAttribute('aria-invalid', 'true');
      },
      true
    );

    document.addEventListener('input', function (event) {
      var field = event.target;
      if (!inScope(field)) return;
      var el = errorFor(field, false);
      if (!el || el.hidden) return;
      if (field.validity.valid) {
        el.hidden = true;
        el.textContent = '';
        field.removeAttribute('aria-invalid');
      } else {
        el.textContent = field.validationMessage;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
